import { render, staticRenderFns } from "./PricesCardDefault.vue?vue&type=template&id=5b33ee37&"
import script from "./PricesCardDefault.vue?vue&type=script&lang=js&"
export * from "./PricesCardDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports